/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useMediaQueries } from "@/shared";

import { creditsObjectType } from "../../../types";
import LegendSingleCard from "./LegendSingleCard";

interface CreditsLegendCardsProps {
  creditsObjectArray: creditsObjectType[] | null;
}

const CreditsLegendCards = ({
  creditsObjectArray
}: CreditsLegendCardsProps) => {
  const { toLg } = useMediaQueries();

  return (
    <div
      css={css({
        display: "flex",
        gap: "16px",
        flexDirection: toLg ? "column" : "row"
      })}
    >
      {creditsObjectArray?.map(item => (
        <LegendSingleCard
          key={`legend_card_${item.name}`}
          item={item}
          toLg={toLg}
        />
      ))}
    </div>
  );
};

export default CreditsLegendCards;
